import { render, staticRenderFns } from "./ProjectComponent.vue?vue&type=template&id=11566e19&scoped=true"
import script from "./ProjectComponent.vue?vue&type=script&lang=js"
export * from "./ProjectComponent.vue?vue&type=script&lang=js"
import style0 from "./ProjectComponent.vue?vue&type=style&index=0&id=11566e19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11566e19",
  null
  
)

export default component.exports